import { NgModule } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { state } from '@angular/animations';
import { Observable } from 'rxjs';
import { PageNotFoundComponent } from './shared-components/page-not-found/page-not-found.component';
import { NoPermissionComponent } from './shared-components/no-permission/no-permission.component';


const routes: Routes = [
  
  { path: '', pathMatch: 'full', redirectTo: '/my-feedback' },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule) },
  { path: 'tasks', loadChildren: () => import('./pages/tasks/tasks.module').then(m => m.TasksModule) },
  { path: 'work-dashboard', loadChildren: () => import('./pages/my-tasks/my-tasks.module').then(m => m.MyTasksModule) },
  { path: 'my-tasks', redirectTo: 'work-dashboard', pathMatch: 'full' },
  { path: 'reports', loadChildren: () => import('./pages/reports/reports.module').then(m => m.ReportsModule) },
  { path: 'deployments', loadChildren: () => import('./pages/deployments/deployments.module').then(m => m.DeploymentsModule) },
  { path: 'emails', loadChildren: () => import('./pages/emails/emails.module').then(m => m.EmailsModule) },
  { path: 'my-emails', loadChildren: () => import('./pages/emails/emails.module').then(m => m.EmailsModule) },
  { path: 'domains', loadChildren: () => import('./pages/domains/domains.module').then(m => m.DomainsModule) },
  { path: 'feedback', loadChildren: () => import('./pages/feedback/feedback.module').then(m => m.FeedbackModule) },
  { path: 'my-feedback', loadChildren: () => import('./pages/feedback/feedback.module').then(m => m.FeedbackModule) },
  { path: 'greetings', loadChildren: () => import('./pages/greetings/greetings.module').then(m => m.GreetingsModule) },
  { path: 'birthday-cards', loadChildren: () => import('./pages/greetings/greetings.module').then(m => m.GreetingsModule) },
  { path: 'anniversary-cards', loadChildren: () => import('./pages/greetings/greetings.module').then(m => m.GreetingsModule) },
  { path: 'templates', loadChildren: () => import('./pages/greetings-template/greetings-template.module').then(m => m.GreetingsTemplateModule) },
  // { path: 'my-feedback', loadChildren: () => import('./pages/my-feedback/my-feedback.module').then(m => m.MyFeedbackModule) },
  { path: 'settings', loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule) },
  { path: 'my-profile', loadChildren: () => import('./pages/my-profile/my-profile.module').then(m => m.MyProfileModule) },
  { path: 'no-permission', component: NoPermissionComponent },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

 
 }
